var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 43,
    viewBox: "0 0 74 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 41.5H15.5H28",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 30.5H15.5H28",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.5H15.5H28",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5H15.5H28",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0L2 14",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 0V14",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 29L2 43",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 29V43",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46 41.5H58.5H71",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46 30.5H58.5H71",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29V43",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72 29V43",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12.5H58.5H71",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46 1.5H58.5H71",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0V14",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72 0V14",
    stroke: "#5DEE7A",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.7452,
    y1: 12.3332,
    x2: 45.7452,
    y2: 31.3332,
    stroke: "#5DEE7A",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.2548,
    y1: 31.3332,
    x2: 45.2548,
    y2: 12.3332,
    stroke: "#5DEE7A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchTask);
export default __webpack_public_path__ + "static/media/match-task.059049a312c50b188fe8b548655fb790.svg";
export { ForwardRef as ReactComponent };